import { ApiLanguage } from '@/models/language';
import { ref, Ref } from 'vue';

const language: Ref<ApiLanguage | null> = ref(null);

const useLanguage = () => language;
export { useLanguage };
